import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from "../components/Tooltip";
import uuid from "react-native-uuid";
import {omit} from "lodash";

const TextWithTooltip = props => {
  const [id, setId] = React.useState('t' + uuid.v4());
  const Tag = props.tag

  return <React.Fragment>
    <Tag
      id={id}
      {...omit(props, ['tooltipTrigger'])}
    >{props.children}</Tag>
    {props.tooltip && <Tooltip className="tooltip-on-modal" msg={props.tooltip} id={id} trigger={props.tooltipTrigger} delay={props.delay} />}
  </React.Fragment>;
};

TextWithTooltip.defaultProps = {
  tooltipTrigger: 'hover',
  tag: 'span',
};

TextWithTooltip.propTypes = {
  tag: PropTypes.string,
  delay: PropTypes.number,
  tooltipTrigger: PropTypes.string,
  tooltip: PropTypes.string,
};

export default TextWithTooltip;
